// en_pms_groups.ts
// Tłumaczenia dla PMS.Groups.tsx

export const enPmsGroups = {

  title:       "Groups and events",
  description: "Operational overview of group reservations and linked events.",
  filters:     "Filters",
  filtersHint: "Quickly narrow down group reservations with many events.",
  none:        "None",

} as const;

export default enPmsGroups;
